import { Controller } from "@hotwired/stimulus"

// A farm Field Task Unit's name, shown as text until «Editar» opens its rename form in place. Typing a name another unit answers to (FieldTaskUnit.words_on)
// turns Guardar into «Fusionar» and shows what moves; the button then submits merge_into, the unit the page warned
// about. A reserved name, or jornal or the hidden day as target, shows its error instead and can't be saved.
export default class extends Controller {
  static targets = ["display", "form", "editButton", "input", "submit", "hint", "warning", "targetName", "reservedError", "dayPaidError"]
  static values = { unitId: Number, original: String, words: Object, reserved: Array, saveLabel: String, mergeLabel: String }

  connect() {
    this.update()
  }

  edit() {
    this.#toggleEditing(true)
    this.inputTarget.focus()
    this.inputTarget.select()
  }

  cancel() {
    this.inputTarget.value = this.originalValue
    this.#toggleEditing(false)
    this.update()
  }

  update() {
    const word = this.#normalize(this.inputTarget.value)
    const reserved = this.reservedValue.includes(word)
    const target = reserved ? null : this.wordsValue[word]
    const merge = target && target.id !== this.unitIdValue
    const dayPaid = merge && target.dayPaid
    const unchanged = !word || word === this.#normalize(this.originalValue) || (target && !merge)

    this.reservedErrorTarget.classList.toggle("hidden", !reserved)
    this.dayPaidErrorTarget.classList.toggle("hidden", !dayPaid)
    this.warningTarget.classList.toggle("hidden", !merge || dayPaid)
    this.hintTarget.classList.toggle("hidden", reserved || merge)
    if (merge) this.targetNameTarget.textContent = target.label

    this.submitTarget.disabled = unchanged || reserved || dayPaid
    this.submitTarget.textContent = merge && !dayPaid ? this.mergeLabelValue : this.saveLabelValue
    this.submitTarget.value = merge && !dayPaid ? target.id : ""
  }

  #toggleEditing(editing) {
    this.formTarget.classList.toggle("hidden", !editing)
    this.displayTarget.classList.toggle("hidden", editing)
    this.editButtonTarget.classList.toggle("hidden", editing)
  }

  #normalize(value) {
    return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").trim().toLowerCase()
  }
}
